/* Longevity Formulas share cards.
   LFShare.open({ kicker, big, unit, headline, rows: [{label, value, pct}], footer, url, filename, text })
   Draws a 1080x1350 PNG on a canvas, then offers native share (phones), download and copy link. */
(function () {
  var W = 1080, H = 1350;
  var C = { ink: '#0e1b4d', blue: '#4770db', mint: '#7fe0b2', gold: '#f5c451', coral: '#ff8a7a', white: '#ffffff' };
  function font(weight, size) {
    var fam = getComputedStyle(document.body).getPropertyValue('--font-heading-family') || 'sans-serif';
    return weight + ' ' + size + 'px ' + fam.trim();
  }
  function bodyFont(weight, size) {
    var fam = getComputedStyle(document.body).getPropertyValue('--font-body-family') || 'sans-serif';
    return weight + ' ' + size + 'px ' + fam.trim();
  }
  function colourFor(v) { return v >= 80 ? C.mint : v >= 50 ? C.gold : C.coral; }
  function round(ctx, x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }
  function wrap(ctx, text, x, y, maxW, lh) {
    var words = String(text).split(' '), line = '', lines = [];
    words.forEach(function (w) { var t = line ? line + ' ' + w : w; if (ctx.measureText(t).width > maxW && line) { lines.push(line); line = w; } else line = t; });
    if (line) lines.push(line);
    lines.forEach(function (l, i) { ctx.fillText(l, x, y + i * lh); });
    return lines.length * lh;
  }
  function draw(o) {
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var ctx = cv.getContext('2d');
    var g = ctx.createLinearGradient(0, 0, W, H); g.addColorStop(0, '#13246a'); g.addColorStop(1, C.ink);
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    var rg = ctx.createRadialGradient(W, 0, 10, W, 0, 900); rg.addColorStop(0, 'rgba(71,112,219,.55)'); rg.addColorStop(1, 'rgba(71,112,219,0)');
    ctx.fillStyle = rg; ctx.fillRect(0, 0, W, H);
    /* Wordmark */
    ctx.fillStyle = C.white; ctx.font = bodyFont(600, 40); ctx.textBaseline = 'alphabetic';
    ctx.fillText('LONGEVITY FORMULAS', 80, 124);
    ctx.fillStyle = 'rgba(255,255,255,.6)'; ctx.font = bodyFont(600, 28);
    ctx.fillText(String(o.kicker || '').toUpperCase(), 80, 230);
    /* Ring */
    var cx = 250, cy = 420, r = 150, v = Math.max(0, Math.min(100, +o.ring || 0));
    ctx.lineWidth = 26; ctx.lineCap = 'round';
    ctx.strokeStyle = 'rgba(255,255,255,.14)'; ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.stroke();
    if (o.ring !== undefined) { ctx.strokeStyle = colourFor(v); ctx.beginPath(); ctx.arc(cx, cy, r, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * v / 100); ctx.stroke(); }
    ctx.fillStyle = C.white; ctx.textAlign = 'center'; ctx.font = font(800, String(o.big).length > 3 ? 104 : 132);
    ctx.fillText(o.big, cx, cy + 40);
    ctx.font = bodyFont(500, 30); ctx.fillStyle = 'rgba(255,255,255,.7)'; ctx.fillText(o.unit || '', cx, cy + 92);
    ctx.textAlign = 'left';
    /* Headline beside ring */
    ctx.fillStyle = C.white; ctx.font = font(800, 50);
    wrap(ctx, o.headline || '', 470, 360, 530, 62);
    /* Rows */
    var y = 650;
    (o.rows || []).slice(0, 5).forEach(function (row) {
      ctx.fillStyle = C.white; ctx.font = bodyFont(600, 34); ctx.fillText(row.label, 80, y);
      ctx.textAlign = 'right'; ctx.fillStyle = 'rgba(255,255,255,.85)'; ctx.fillText(row.value, W - 80, y); ctx.textAlign = 'left';
      round(ctx, 80, y + 22, W - 160, 16, 8); ctx.fillStyle = 'rgba(255,255,255,.12)'; ctx.fill();
      if (row.pct !== undefined && row.pct !== null) { round(ctx, 80, y + 22, Math.max(16, (W - 160) * Math.min(100, row.pct) / 100), 16, 8); ctx.fillStyle = colourFor(row.pct); ctx.fill(); }
      y += 84;
    });
    /* Footer challenge */
    round(ctx, 60, H - 250, W - 120, 190, 28); ctx.fillStyle = 'rgba(255,255,255,.08)'; ctx.fill();
    ctx.fillStyle = C.white; ctx.font = font(800, 46); ctx.fillText(o.footer || 'What do you score?', 100, H - 172);
    ctx.fillStyle = C.mint; ctx.font = bodyFont(700, 36); ctx.fillText(o.search || 'Search \u201cLongevity Formulas\u201d to take the test', 100, H - 118);
    ctx.fillStyle = 'rgba(255,255,255,.55)'; ctx.font = bodyFont(500, 26); ctx.fillText((o.url || location.href).replace(/^https?:\/\/(www\.)?/, '').replace(/[?#].*$/, ''), 100, H - 80);
    return cv;
  }
  function toBlob(cv) { return new Promise(function (res) { cv.toBlob(res, 'image/png'); }); }

  var modal;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'lf lf-share';
    modal.innerHTML = '<div class="lf-share__box" role="dialog" aria-modal="true" aria-label="Share your result"><button type="button" class="lf-share__x" aria-label="Close">×</button><img alt="Your result card"><div class="lf-share__btns"><button type="button" class="lf-btn lf-btn--blue" data-a="share">Share</button><button type="button" class="lf-btn lf-btn--ghost" data-a="save">Save image</button><button type="button" class="lf-btn lf-btn--ghost" data-a="copy">Copy link</button></div><p class="lf-small lf-share__msg" aria-live="polite"></p></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('lf-share__x')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return modal;
  }
  function close() { if (modal) modal.classList.remove('is-open'); }
  function track(name, o) { try { if (window.gtag) gtag('event', name, { event_category: 'share', event_label: o.kicker }); } catch (e) {} }

  window.LFShare = {
    open: function (o) {
      var m = ensureModal(), cv = draw(o), msg = m.querySelector('.lf-share__msg');
      var url = o.url || location.href.split('#')[0];
      m.querySelector('img').src = cv.toDataURL('image/png');
      msg.textContent = '';
      var file = null;
      toBlob(cv).then(function (b) { file = new File([b], (o.filename || 'longevity-result') + '.png', { type: 'image/png' }); });
      var shareBtn = m.querySelector('[data-a=share]');
      shareBtn.hidden = !(navigator.share);
      shareBtn.onclick = function () {
        var data = { title: o.headline, text: o.text, url: url };
        if (file && navigator.canShare && navigator.canShare({ files: [file] })) data.files = [file];
        navigator.share(data).then(function () { track('share_result', o); }).catch(function () {});
      };
      m.querySelector('[data-a=save]').onclick = function () {
        var a = document.createElement('a'); a.href = cv.toDataURL('image/png'); a.download = (o.filename || 'longevity-result') + '.png'; document.body.appendChild(a); a.click(); a.remove();
        msg.textContent = 'Image saved. Post it with the link so friends can try it.'; track('save_result_image', o);
      };
      m.querySelector('[data-a=copy]').onclick = function () {
        var t = (o.text ? o.text + ' ' : '') + url;
        (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { msg.textContent = 'Link copied.'; }, function () { msg.textContent = t; });
        track('copy_result_link', o);
      };
      m.classList.add('is-open');
      m.querySelector('.lf-share__x').focus();
    }
  };
})();
